export default __webpack_public_path__ + "static/media/Group8891.7299d402.svg";